import MHadesCarousel from '../carousels/MHadesCarousel';
import React, { ReactNode, useCallback, useState } from 'react';
import afrodita from '../../../../assets/images/games/m-game/percy/final/afrodita.webp';
import apolon from '../../../../assets/images/games/m-game/percy/final/apolon.webp';
import ares from '../../../../assets/images/games/m-game/percy/final/ares.webp';
import artemis from '../../../../assets/images/games/m-game/percy/final/artemis.webp';
import asklepius from '../../../../assets/images/games/m-game/percy/final/asklepius.webp';
import atena from '../../../../assets/images/games/m-game/percy/final/atena.webp';
import chronos from '../../../../assets/images/games/m-game/percy/final/chronos.webp';
import demeter from '../../../../assets/images/games/m-game/percy/final/demeter.webp';
import dionyzos from '../../../../assets/images/games/m-game/percy/final/dionyzos.webp';
import gaia from '../../../../assets/images/games/m-game/percy/final/gaia.webp';
import hades from '../../../../assets/images/games/m-game/percy/final/hades.webp';
import hefaistos from '../../../../assets/images/games/m-game/percy/final/hefaistos.webp';
import hekate from '../../../../assets/images/games/m-game/percy/final/hekate.webp';
import helios from '../../../../assets/images/games/m-game/percy/final/helios.webp';
import hera from '../../../../assets/images/games/m-game/percy/final/hera.webp';
import hermes from '../../../../assets/images/games/m-game/percy/final/hermes.webp';
import hestia from '../../../../assets/images/games/m-game/percy/final/hestia.webp';
import hypnos from '../../../../assets/images/games/m-game/percy/final/hypnos.webp';
import iris from '../../../../assets/images/games/m-game/percy/final/iris.webp';
import nike from '../../../../assets/images/games/m-game/percy/final/nike.webp';
import pan from '../../../../assets/images/games/m-game/percy/final/pan.webp';
import poseidon from '../../../../assets/images/games/m-game/percy/final/poseidon.webp';
import zeus from '../../../../assets/images/games/m-game/percy/final/zeus.webp';

import imageLast from '../../../../assets/images/games/m-game/percy/final/last.webp';

export default function MHadesCipher() {
    const [selectedSlide, setSelectedSlide] = useState(0);
    const [images, setImages] = useState([
        { url: afrodita, id: 14 },
        { url: hermes, id: 3 },
        { url: demeter, id: 7 },
        { url: chronos, id: 23 },
        { url: dionyzos, id: 18 },
        { url: zeus, id: 1 },
        { url: apolon, id: 9 },
        { url: iris, id: 21 },
        { url: gaia, id: 12 },
        { url: poseidon, id: 11 },
        { url: ares, id: 6 },
        { url: hypnos, id: 13 },
        { url: hestia, id: 2 },
        { url: hefaistos, id: 4 },
        { url: hades, id: 15 },
        { url: pan, id: 17 },
        { url: hera, id: 10 },
        { url: helios, id: 20 },
        { url: asklepius, id: 22 },
        { url: atena, id: 5 },
        { url: hekate, id: 16 },
        { url: artemis, id: 8 },
        { url: nike, id: 19 },
        { url: imageLast, id: 100 },
    ]);

    const [films, setFilms] = useState([
        { name: 'Zeus', id: 1 },
        { name: 'Proteus', id: 1000 },
        { name: 'Ajax', id: 1000 },
        { name: 'Hestia', id: 2 },
        { name: 'Hermes', id: 3 },
        { name: 'Hefaistos', id: 4 },
        { name: 'Antigona', id: 1000 },
        { name: 'Andromeda', id: 1000 },
        { name: 'Helena', id: 1000 },
        { name: 'Aténa', id: 5 },
        { name: 'Ares', id: 6 },
        { name: 'Demeter', id: 7 },
        { name: 'Eros', id: 1000 },
        { name: 'Artemis', id: 8 },
        { name: 'Cassandra', id: 1000 },
        { name: 'Pandora', id: 1000 },
        { name: 'Odysseus', id: 1000 },
        { name: 'Apolón', id: 9 },
        { name: 'Héra', id: 10 },
        { name: 'Poseidon', id: 11 },
        { name: 'Gaia', id: 12 },
        { name: 'Triton', id: 1000 },
        { name: 'Hypnos', id: 13 },
        { name: 'Afrodita', id: 14 },
        { name: 'Morpheus', id: 1000 },
        { name: 'Hádes', id: 15 },
        { name: 'Hekaté', id: 16 },
        { name: 'Pan', id: 17 },
        { name: 'Paris', id: 1000 },
        { name: 'Dionýzos', id: 18 },
        { name: 'Niké', id: 19 },
        { name: 'Plutus', id: 1000 },
        { name: 'Helios', id: 20 },
        { name: 'Iris', id: 21 },
        { name: 'Orpheus', id: 1000 },
        { name: 'Asklepius', id: 22 },
        { name: 'Nemesis', id: 1000 },
        { name: 'Chronos', id: 23 },
    ]);

    const onCompleteSlide = useCallback((idx: number, _item: ReactNode) => {
        setSelectedSlide(idx);
    }, []);

    const removeOnIndex = (n: number) => {
        if (n === images[selectedSlide].id) {
            const filteredImages = images.filter((v) => v.id !== n);
            const filteredFilms = films.filter((v) => v.id !== n);
            setImages(filteredImages);
            setFilms(filteredFilms);
        }
    };
    return (
        <React.Fragment>
            <div className="m-hades">
                <MHadesCarousel onCompleteSlide={onCompleteSlide} images={images} />
                {films && images && films.length > 0 && images.length > 1 && (
                    <div className="m-hades-names-wrapper">
                        {films?.map((f, i) => {
                            return (
                                <div className="m-hades-name" key={i} onClick={() => removeOnIndex(f.id)}>
                                    {f.name}
                                </div>
                            );
                        })}
                    </div>
                )}
                {!images || (images.length === 1 && <div className="m-hades-solved">Hádes je porazený</div>)}
            </div>
        </React.Fragment>
    );
}
